var React = require('react');

function HammerWar (props) {
    return React.createElement("svg",props,[React.createElement("defs",{"key":0},React.createElement("style",null,".fa-secondary{opacity:.4}")),React.createElement("path",{"d":"M384 64v192a32 32 0 0 1-37.26 31.56L192 261.77 37.26 287.55A32 32 0 0 1 0 256V64a32 32 0 0 1 37.26-31.56L192 58.23l154.74-25.78A32 32 0 0 1 384 64z","className":"fa-secondary","key":1}),React.createElement("path",{"d":"M160 52.9V16a16 16 0 0 1 16-16h32a16 16 0 0 1 16 16v36.9l-32 5.33zm0 246.64V496a16 16 0 0 0 16 16h32a16 16 0 0 0 16-16V299.54l-32-5.33z","className":"fa-primary","key":2})]);
}

HammerWar.defaultProps = {"viewBox":"0 0 384 512","className":"icon"};

module.exports = HammerWar;

HammerWar.default = HammerWar;
